import { SwapHoriz } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { UsersResponse } from 'lib/api/portfolio/types';
import DialogTitle from 'lib/designSystem/Title/DialogTitle';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getUsersToTransfer } from '../../api/portfolio';
import CustomButton from '../../designSystem/Button';
import CenteredCircularProgress from '../../designSystem/CircularProgress';
import Collection from './Components/Collection';
import Commercial from './Components/Commercial';

type TransferType = 'comercial' | 'cobranza' | null;

interface PortfolioTransferProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  userToTransfer: number | undefined;
}

const PortfolioTransfer: React.FC<PortfolioTransferProps> = (props) => {
  const { open, setOpen, userToTransfer } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<UsersResponse>([]);
  const [showTypeSelection, setShowTypeSelection] = useState<boolean>(true);
  const [transferType, setTransferType] = useState<TransferType>(null);

  const fetchUsers = async () => {
    setLoading(true);
    const response = await getUsersToTransfer(dispatch);
    if (response) setUsers(response);
    setLoading(false);
  };

  useEffect(() => {
    if (open) {
      void fetchUsers();
      setShowTypeSelection(true);
      setTransferType(null);
    }
  }, [open]);

  const handleTypeSelection = (type: TransferType) => {
    setTransferType(type);
    setShowTypeSelection(false);
  };

  if (loading) return <CenteredCircularProgress />;

  if (showTypeSelection) {
    return (
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          onClose={() => setOpen(false)}
          title="Selecciona el tipo de cartera"
          icon={<SwapHoriz color="primary" />}
          color="primary"
        />
        <DialogContent>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              marginTop: '16px',
            }}
          >
            <CustomButton
              variant="outlined"
              onClick={() => handleTypeSelection('comercial')}
              fullWidth
              size="medium"
            >
              Cartera Comercial
            </CustomButton>
            <CustomButton
              variant="outlined"
              onClick={() => handleTypeSelection('cobranza')}
              fullWidth
              size="medium"
              disabled={!users || users.length === 0}
            >
              Cartera Cobranza
            </CustomButton>
          </div>
        </DialogContent>
        <DialogActions>
          <CustomButton color="secondary" onClick={() => setOpen(false)}>
            Cancelar
          </CustomButton>
        </DialogActions>
      </Dialog>
    );
  }

  if (transferType === 'comercial') {
    return (
      <Commercial
        open={open}
        setOpen={setOpen}
        options={users}
        loading={loading}
        setLoading={setLoading}
        userToTransfer={userToTransfer}
      />
    );
  }

  if (transferType === 'cobranza') {
    return (
      <Collection
        open={open}
        setOpen={setOpen}
        options={users}
        loading={loading}
        setLoading={setLoading}
        userToTransfer={userToTransfer}
      />
    );
  }

  return null;
};

export default PortfolioTransfer;
